export const LP_TITLE = 'Lesson Plan';
export const LP_IPLAN_TUTORIAL_DESKTOP_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialIplanLpDesktop.webp`;
export const LP_IPLAN_TUTORIAL_MOBILE_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialIplanLpMobile.webp`;
export const LP_TUTORIAL_DESKTOP_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialLp_Desktop.webp`;
export const LP_TUTORIAL_MOBILE_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialLp_Mobile.webp`;

// Video tutorial URLs - Replace with actual video URLs when available
export const LP_TUTORIAL_VIDEO_URL = 'https://youtu.be/9GHVT8ENu74';
